var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class AspectCssTransition {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    allTransitionEvents = observable.array();
    isTransitionRunning = false;
}
__decorate([
    observable.shallow
], AspectCssTransition.prototype, "allTransitionEvents", void 0);
__decorate([
    observable
], AspectCssTransition.prototype, "isTransitionRunning", void 0);
